import { SearchContactPersonsEmail } from "@graphql";
import locale from "@bonliva-crm/locale";
import { MultiCreatableSelectAsync, MultiSelectAsync } from "@bonliva-crm/ui";
import { CSSProperties } from "react";
import * as yup from "yup";

type Value = { email?: string; name?: string };

type Option = {
  label: string;
  value: Value;
};

type Props = {
  value: Value[];
  onChange: (value: Value[]) => void;
  creatable?: boolean;
  style?: CSSProperties;
  disabled?: boolean;
};

const emailSchema = yup.string().email().required();

export const ContactPersonEmailSearch = (props: Props) => {
  const searchContactPersons = (text: string) => {
    return SearchContactPersonsEmail.func({
      filter: {
        text: [text],
        withEmailAttached: true
      },
      limit: 99,
      skip: 0
    }).then((res) => {
      return res.data.contactPersons.items.map((x) => ({
        label: x.Email,
        value: {
          email: x.Email,
          name: x.Name ?? ""
        }
      }));
    });
  };

  return (
    <div style={props.style}>
      {props.creatable ? (
        <MultiCreatableSelectAsync<Option>
          loadOptions={searchContactPersons}
          placeholder=""
          value={props.value.map((v) => ({ label: v.email, value: v }))}
          onChange={(value) => props.onChange(value.map((v) => v.value))}
          onCreateOption={(input) =>
            props.onChange([...props.value, { email: input, name: "" }])
          }
          isValidNewOption={(option) => emailSchema.isValidSync(option)}
          formatCreateLabel={(input) => `${locale.use} "${input}"`}
          isOptionSelected={(option) =>
            props.value.some((v) => v.email === option.value.email)
          }
          styleProps={{ menu: { showBorder: true }, control: { showBorder: false } }}
          isDisabled={props.disabled}
        />
      ) : (
        <MultiSelectAsync<Option>
          loadOptions={searchContactPersons}
          placeholder=""
          value={props.value.map((v) => ({ label: v.email, value: v }))}
          onChange={(value) => props.onChange(value.map((v) => v.value))}
          isOptionSelected={(option) =>
            props.value.some((v) => v.email === option.value.email)
          }
          styleProps={{ menu: { showBorder: true }, control: { showBorder: false } }}
          isDisabled={props.disabled}
        />
      )}
    </div>
  );
};
